import { render, staticRenderFns } from "./CustomerSearchModal.vue?vue&type=template&id=0b5246aa"
import script from "./CustomerSearchModal.vue?vue&type=script&lang=js"
export * from "./CustomerSearchModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports